module.exports = __webpack_public_path__ + "static/media/line.abbe58d5.svg";